import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=495395f4&scoped=true&"
import script from "./CTA.vue?vue&type=script&lang=js&"
export * from "./CTA.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CTA.vue?vue&type=style&index=0&id=495395f4&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "495395f4",
  "7e5c80e8"
  
)

export default component.exports